import { Box, TouchableBox } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";

import { EmaginThumbnail } from "./FileThumbnail";
import { SuggestionItemTitle } from "./SuggestionItemTitle";
import { useSuggestionItemLayout } from "./useSuggestionItemLayout";
import { EmaginItem_IntegrationEmaginFlyer$key } from "./__generated__/EmaginItem_IntegrationEmaginFlyer.graphql";

export function EmaginItem(props: {
  integrationEmaginFlyer: EmaginItem_IntegrationEmaginFlyer$key;
  onPress?(_: { id: string; title: string }): void;
}) {
  const { width, height, size } = useSuggestionItemLayout();

  const data = useFragment(
    graphql`
      fragment EmaginItem_IntegrationEmaginFlyer on IntegrationEmaginFlyer {
        id
        eMaginId
        title
        imageUrls
      }
    `,
    props.integrationEmaginFlyer
  );

  if (!data.eMaginId) {
    return null;
  }

  return (
    <TouchableBox
      hitSlop={{ left: 15, right: 15 }}
      style={{
        width,
        height,
        alignItems: "center",
      }}
      onPress={() => {
        if (!data.eMaginId) {
          throw new Error("EmaginItem.tsx");
        }
        props.onPress?.({ id: data.eMaginId, title: data.title ?? "" });
      }}
    >
      <Box>
        <EmaginThumbnail
          size={size}
          color="rgb(84,82,246)"
          type="integration"
          image={{
            uri: data.imageUrls[0]?.slice(),
            type: "local",
          }}
        />
        <SuggestionItemTitle>{data.title}</SuggestionItemTitle>
      </Box>
    </TouchableBox>
  );
}
